

import { Button, Col, Input, Row, Table, Modal, Switch, Popconfirm, notification, Segmented, Spin } from "antd";
import { useEffect, useState } from "react";
import { EditOutlined, DeleteOutlined, BarsOutlined, AppstoreOutlined } from '@ant-design/icons';
// import { AddTags } from "./AddTags";
// import { setHeaderName } from "../../../../services/SetHeaderName";
// import { AddPlanPricing } from "./AddPlanPricing";
import '../style/HerbsManagement.scss'
import { AddHerbsDetails } from "./AddHerbsDetails";
import { listOfHerbManagementApi, updateHerbManagementApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../config/constant";
import { Link } from "react-router-dom";
import { setHeaderName } from "../../../../../services/SetHeaderName";

export const HerbsManagement = () => {
    const [isModalVisible, setIsModalVisible] = useState(false)

    const data = [
        {
            id: '1001',
            herb: 'Amalaki',
            quantity: '5',
            unit_id: "1",
            unit: {
                id: '1',
                name: "Miligrams"
            },
            remark: "Amalaki Remarks",
            kapha: true,
            pitta: false,
            vata: true,
            active: false,
            typeOfHerb: "Kitchen Herb"
        },
        {
            id: '1002',
            herb: 'Ajwain',
            quantity: '3',
            unit_id: "2",
            unit: {
                id: '2',
                name: "Teaspoon"
            },
            remark: "remark of ajwain",
            kapha: false,
            pitta: true,
            vata: false,
            active: false,
            typeOfHerb: "Ayurveda Medicine"
        },
        {
            id: '1003',
            herb: 'Caster Oil',
            quantity: '7',
            unit_id: "3",
            unit: {
                id: '3',
                name: "Liters"
            },
            remark: "remark of Caster Oil",
            kapha: true,
            pitta: true,
            vata: true,
            active: false,
            typeOfHerb: "Allopathic Medicine"
        },
    ];

    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [kaphaStatus, setKaphaStatus] = useState(false)
    const [pittaStatus, setPittaStatus] = useState(false)
    const [vataStatus, setVataStatus] = useState(false)
    const [viewPage, setViewPage] = useState("list")
    const [editHerbManagement, setEditHerbManagement] = useState(false)
    const [editHerbManagementRecord, setEditHerbManagementRecord] = useState()

    const [herbData, setHerbData] = useState()


    // get the list of alll available plans 
    const getListOfHerbsManagement = () => {
        setLoading(true)
        listOfHerbManagementApi()
            .then((res) => {
                if (res.status === 200) {

                    let data = res.data.data
                    let userId = localStorage.getItem('id')
                    let HerbItemsArray = []
                    if (data.length > 0) {
                        data.map((element) => {
                            // all recipes that has edit_flag false 
                            if (!element.edit_flag) {
                                HerbItemsArray.push(element)
                            }
                            // and compare loginuer id and recipe user id if match and flag is true also display those recipes 
                            if (element.edit_flag == true && element.user_id == userId) {
                                HerbItemsArray.push(element)
                            }
                        })
                    }
                    setDataSource(HerbItemsArray);
                    setDisplayData(HerbItemsArray);
                    // setKaphaStatus(res.data.data.kapha) 
                    // setPittaStatus(res.data.data.pitta)
                    // setVataStatus(res.data.data.vata)
                }
                setLoading(false)

            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        setHeaderName("Herbs Management")
        getListOfHerbsManagement()
    }, []);

    useEffect(() => {
        <AddHerbsDetails
            getListOfHerbsManagement={getListOfHerbsManagement}
            setEditHerbManagement={setEditHerbManagement}
            editHerbManagement={editHerbManagement}
            editHerbManagementRecord={editHerbManagementRecord}
        />
    }, [editHerbManagementRecord, editHerbManagement])
    // // call when user click on edit
    // const editHerbManagement = (data) => {
    //     setButtonName("UPDATE")
    //     form.setFieldsValue({ 'herb': data.herb })
    //     form.setFieldsValue({ 'quantity': data.quantity })
    //     form.setFieldsValue({ 'name': data.unit_id })
    //     form.setFieldsValue({ 'name': data.remark })
    //     // form.setFieldsValue({ 'name': data.name })
    //     // form.setFieldsValue({ 'name': data.name })
    //     setEditHerbManagementRecord(data);
    // }

    const onChange = (checked, data, fieldName) => {
        let updatedData = data;
        updatedData[fieldName] = checked;

        updateHerbManagementApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Herb Update successfully",
                    });
                    getListOfHerbsManagement()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'name',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.id - b.id,
        //     // render: (text) => <a>{text}</a>,
        // },
        {
            title: 'Herb',
            dataIndex: 'herb',
            key: 'herb',
            sorter: (a, b) => a.herb.localeCompare(b.herb),
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
        },
        {
            title: 'Unit',
            dataIndex: 'unit',
            key: 'unit',
            render: (text, data) => <p>{text?.name}</p>
        },
        {
            title: 'Remark',
            dataIndex: 'remark',
            key: 'remark',
        },
        {
            title: 'Herb Type',
            dataIndex: 'typeOfHerb',
            key: 'typeOfHerb',
        },
        {
            title: 'Kapha',
            dataIndex: 'kapha',
            key: 'kapha',
            render: (text, data) => <>
                {/* <Switch checked={kaphaStatus} onChange={(e) => {onChange(text, data,'kapha');setKaphaStatus(e)}} /> */}
                <Switch checked={text} onChange={(e) => { onChange(e, data, 'kapha'); setKaphaStatus(e) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.kapha == value,
        },
        {
            title: 'Pitta',
            dataIndex: 'pitta',
            key: 'pitta',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { onChange(e, data, 'pitta'); setPittaStatus(e) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.pitta == value,
        },
        {
            title: 'Vata',
            dataIndex: 'vata',
            key: 'vata',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { onChange(e, data, 'vata'); setVataStatus(e) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.vata == value,
        },
        // {
        //     title: 'Status',
        //     dataIndex: 'status',
        //     key: 'status',
        //     render: (text, data) => <>
        //         <Switch checked={data.status} onChange={(e) => onChange(text, data)} />
        //     </>,
        //     filters: [
        //         { text: "Active", value: true },
        //         { text: "Deactive", value: false },
        //     ],
        //     onFilter: (value, record) => record.status == value,
        // },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={() => { setViewPage("add_form"); setEditHerbManagementRecord(record); setEditHerbManagement(true) }} />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    // filter data according to user search input 
    useEffect(() => {
        filterHerb(herbData);
    }, [herbData]);

    // filter Herb Data
    const filterHerb = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.herb.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.typeOfHerb.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    return (
        <>
            <Segmented
                className="ms-4 mb-0 mt-2 pt-2 align-self-center"
                value={viewPage}
                size={"large"}
                onChange={(e) => setViewPage(e)}
                options={[
                    {
                        label: 'List',
                        value: 'list',
                        icon: <BarsOutlined />,
                    },
                    {
                        label: 'Form',
                        value: 'add_form',
                        icon: <AppstoreOutlined />,
                    },
                ]}
            />
            {
                viewPage == "add_form" ?
                    <AddHerbsDetails
                        getListOfHerbsManagement={getListOfHerbsManagement}
                        setEditHerbManagement={setEditHerbManagement}
                        editHerbManagement={editHerbManagement}
                        editHerbManagementRecord={editHerbManagementRecord}
                    />
                    :
                    <div className="AssignedHerbsList">
                        <Row className="mb-2">
                            <Col md={4} xl={3} className="align-self-center">
                                <h4 className="ms-2 mb-0">Herbs List</h4>
                            </Col>
                            <Col md={8} xl={15} className="text-end align-self-center pe-4">
                                <h6 className="mb-0">Total Herbs:  {displayData.length > 0 ? displayData.length : 0}   </h6>
                            </Col>
                            <Col md={12} xl={6} className="align-self-center pe-2">
                                <Input.Search placeholder="Search Herb"
                                    //  onChange={e => {
                                    // let currValue = e.target.value;
                                    // let filteredData = data.filter(entry =>
                                    //     entry.herb.toLowerCase().includes(currValue.toLowerCase()) ||
                                    //     entry.unit.name.toLowerCase().includes(currValue.toLowerCase()) ||
                                    //     entry.typeOfHerb.toLowerCase().includes(currValue.toLowerCase())
                                    // );
                                    // setDataSource(filteredData);
                                    // }} 
                                    onChange={(e) => { filterHerb(e.target.value); setHerbData(e.target.value) }}
                                    className="p-2" />
                            </Col>
                        </Row>
                        <Spin spinning={loading} className="spinner-code">
                            <Row>
                                <Table
                                    columns={columns}
                                    rowKey="id"
                                    dataSource={displayData}
                                    // pagination={false}
                                    scroll={{ x: "max-content" }}
                                    className="w-100"
                                />
                            </Row>
                        </Spin>
                    </div>
            }

        </>
    )
}
